export enum TerminationStatusEnum {
  IN_PROCESS = 'IN_PROCESS',
  COMPLETE = 'COMPLETE',
  ALREADY_TERMINATED = 'ALREADY_TERMINATED',
  FAILED = 'FAILED',
}
